  
<mat-progress-bar
    *ngIf="loading" color="accent" mode="indeterminate">
</mat-progress-bar>


<router-outlet></router-outlet>
